import { api } from 'app/config/apiConfig';
import { UpdateUserParams } from '../model/types';
import { USERS_PATH } from '../utils/constants';

export const updateUserApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateUser: builder.mutation<void, { userId: string; params: Partial<UpdateUserParams> }>({
      query: ({ userId, params }) => ({
        url: `${USERS_PATH}/${userId}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const { useUpdateUserMutation } = updateUserApi;
